import { gqlMutate, gqlQuery } from '@hapana/shared/web/services/requests.service'

import * as mutations from './graphql/equipment-queue.mutations'
import { equipmentQueueClientsQuery } from './graphql/equipments.queries'

export const addClientToEquipmentQueue = ({ clientId, equipmentId }) =>
  gqlMutate({
    mutation: mutations.addClientToEquipmentQueue,
    variables: { clientId, equipmentId },
  })

export const removeClientFromEquipmentQueue = ({ clientId, equipmentId }) =>
  gqlMutate({
    mutation: mutations.removeClientFromEquipmentQueue,
    variables: { clientId, equipmentId },
  })

export const notifyClientInEquipmentQueue = ({ clientId, siteId, equipmentId }) =>
  gqlMutate({
    mutation: mutations.notifyClientInEquipmentQueue,
    variables: { clientId, siteId, equipmentId },
  })

export const getEquipmentQueueClients = gqlQuery({
  key: 'EQUIPMENT_QUEUE_CLIENTS',
  query: equipmentQueueClientsQuery,
})
